import styled from 'styled-components';
import {MAIN_COLOR} from "../../globalThemes";

export const StyledMenu = styled.div`
    height: 190px;
    position: fixed;
    right: 0;
    top: 45%;  
    z-index: 500;  
    display: flex;
    align-items: flex-end;
    flex-direction: column;
    
    @media (max-width: 480px) {
        height: 95px;
    }
`;

export const MenuTitleContainer = styled.div`
    height: 100%;
    display: none;
    flex-direction: column;
    justify-content: center;
    flex: 2;
`;

export const MenuTitle = styled.p`
    font-family: BlenderProBold, serif;
    color: ${MAIN_COLOR};
    font-size: 13px;
    font-weight: bold;
    margin: 0;
    
    @media (max-width: 480px) {
        font-size: 11px;
    }
`;

export const MenuText = styled.span`
    font-family: Roboto Condensed, serif;
    color: white;
    font-size: 10px;
    font-weight: 300;
    margin-top: 5px;
    
    @media (max-width: 480px) {
        font-size: 9px;
        margin-top: 1px;
    }
`;

export const MenuItem = styled.a`
    width: 60px;
    height: 60px;    
    background-color: black;
    margin-bottom: 10px;
    border-bottom: 1px solid ${MAIN_COLOR};
    border-left: 1px solid ${MAIN_COLOR};
    border-top: 1px solid ${MAIN_COLOR};
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;  
    transition: 1s all;
    text-decoration: none;
    
    &:hover {
        width: 250px;
    } 
    
    &:hover ${MenuTitleContainer}{
        display: flex;
    } 
    
    @media (max-width: 480px) {
        width: 30px;
        min-height: 30px;
    }
`;

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    width: ${({width}) => width ?? 30}px;
    height: ${({height}) => height ?? 30}px;
`;
